import LienholderFormInputs from '../../tradeForm/lienholderForm/LienholderFormInputs.interstate';
import { SingleTradeInFormProvider } from '../../tradeForm/MultiTradeIn/TradeInFormProvider';
import { ExpandableArea } from '@makemydeal/dr-dash-components';
import { OUTSIDE_LIENHOLDER_HEADER_NAME } from './constants';

import { Box } from '@interstate/components/Box';
import { Button } from '@interstate/components/Button';
import { useOutsideLienholderForm } from './useOutsideLienholderForm';

const OutsideLienholderExpandableSection = () => {
    const { lienholderProps, onClearAll } = useOutsideLienholderForm();

    return (
        <ExpandableArea expandableId={OUTSIDE_LIENHOLDER_HEADER_NAME} shouldAllowOverflow>
            <Box display="flex" justifyContent="flex-end">
                <Button buttonStyle="tertiary" data-testid="lienholder-clear-all-button" onClick={onClearAll}>
                    Clear All
                </Button>
            </Box>
            <SingleTradeInFormProvider tradeInIndex={0} isOutsideLienholder={true}>
                <LienholderFormInputs {...lienholderProps} />
            </SingleTradeInFormProvider>
        </ExpandableArea>
    );
};

export default OutsideLienholderExpandableSection;
